module.exports = __webpack_public_path__ + "media/store/images/whatsapp-6a260d42c1586a3f1643513ead17c0b5.svg";